import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState('Signing you in...');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        // Retry up to 3 times with delay
        for (let attempt = 0; attempt < 3; attempt++) {
          try {
            await exchangeSession(sessionId);
            window.history.replaceState(null, '', '/dashboard');
            navigate('/dashboard', { replace: true });
            return;
          } catch (err) {
            if (attempt < 2) {
              setStatus('Connecting... please wait');
              await new Promise(r => setTimeout(r, 2000));
            }
          }
        }
        // All retries failed
        setStatus('Something went wrong. Redirecting...');
        setTimeout(() => navigate('/', { replace: true }), 1500);
      } else {
        navigate('/', { replace: true });
      }
    };

    processCallback();
  }, [location.hash, exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FFF2EC]">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin mx-auto text-[#FF6B4A]" />
        <p className="mt-4 text-[#8C7A76]">{status}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
